<script>
//Repositories
import Repositories from '@/repositories';
const DashboardsRepository = Repositories.get('dashboards');

//Mixins
import textMixin from '@/mixins/textMixin';
import dateMixin from '@/mixins/dateMixin';

//Components
import GridComponent from '@/components/widgets/grids/api-linked-grid';

export default {
  props: {
    filters: Object,
    fields: Array,
  },
  components: {
    GridComponent,
  },
  mixins: [textMixin, dateMixin],
  data() {
    return {
      priceHistories: [],
      fullListSize: 0,
      gridContext: null,
      isLoading: false,
    };
  },
  created() {
    this.gridContext = {
      currentPage: 1,
      perPage: this.itemsPerPage,
      sortBy: 'created',
      sortDesc: true,
    };

    this.loadData();
  },
  methods: {
    loadData() {
      this.isLoading = true;
      DashboardsRepository.customREST
        .getItemSupplierPriceHistories({ ...this.filters, ...this.gridContext })
        .then(({ data }) => {
          this.priceHistories = data.data;
          this.fullListSize = data.count;
        })
        .catch(() => {
          this.$toast.errorToast(this.$t('errors.errorLoading'));
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    contextChanged(context) {
      this.gridContext = context;
      this.loadData();
    },
    precentCalcul(priceHistory) {
      if (priceHistory.price - priceHistory.difference != 0) {
        return this.toFloat(
          this.toFloat(priceHistory.price * 100) /
            this.toFloat(priceHistory.price - priceHistory.difference) -
            100
        ).toFixed(2);
      } else {
        return 100;
      }
    },
  },
  computed: {
    currencyFormatter() {
      return this.$store.state.cache.currencyFormatter;
    },
    itemsPerPage() {
      return this.$store.getters['localstorage/getDynamicConfigs'](
        'gridConfig-dashboard-price-histories-grid'
      ).itemsPerPage;
    },
  },
  watch: {
    filters() {
      this.priceHistories = [];
      this.gridContext.currentPage = 1;
      this.loadData();
    },
  },
};
</script>

<template>
  <b-card no-body class="p-3 custom-inventory-shadow">
    <GridComponent
      v-if="gridContext != null"
      id="dashboard-price-histories-grid"
      :fields="fields"
      :items="priceHistories"
      :is-busy="isLoading"
      :nbItems="fullListSize"
      :default-sort="gridContext.sortBy"
      :default-sort-desc="gridContext.sortDesc"
      :current-page="gridContext.currentPage"
      @context-changed="contextChanged"
    >
      <template #cell(supplierName)="data">
        <span
          v-html="
            highlightMatches(
              data.item.supplierName,
              filters != null ? filters.search : ''
            )
          "
        />
      </template>
      <template #cell(itemName)="data">
        <span
          v-html="
            highlightMatches(
              data.item.itemName,
              filters != null ? filters.search : ''
            )
          "
        />
      </template>
      <template #cell(created)="data">
        {{ formatDate(data.item.created) }}
      </template>
      <template #cell(price)="data">
        {{ currencyFormatter.format(data.item.price) }}
      </template>
      <template #cell(difference)="data">
        {{ currencyFormatter.format(data.item.difference) }}
      </template>
      <template #cell(percentage)="data">
        {{ precentCalcul(data.item) + '%' }}
      </template>
    </GridComponent>
  </b-card>
</template>
